import config from "@/../public/static/config.json";
import axios from "axios";
import store from "@/store";
import ErrorService from "@/services/errorService";
import router from "../router";

let url =
    process.env.NODE_ENV === "production"
        ? config.APP_URL_PROD
        : config.APP_URL_DEV;
// const url = "https://api.samaaljawharah.com/";
// const url = "https://10.40.31.19:8081/";
//  config.APP_URL_DEV;

const axiosInstance = axios.create({
    baseURL: url + "/api/",
});

// Request interceptor to add token dynamically
axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.state.auth.accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle different types of errors
        if (!error.response) {
            // Network error (no response from server)
            ErrorService.handleNetworkError(error);
        } else {
            const status = error.response.status;
            const validationErrors = error.response.data?.errors;

            if (validationErrors) {
                const message =
                    ErrorService.handleValidationErrors(validationErrors);
                store.dispatch("toastification/setToast", {
                    message: message,
                    type: "error",
                });
                return Promise.reject(error);
            }

            if (status === 401) {
                // Token is expired or invalid
                store.dispatch("auth/logout");
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            } else if (status === 403) {
                // Access denied - use error service for consistent handling
                ErrorService.handleError(
                    error,
                    "تم رفض الوصول - ليس لديك صلاحية للوصول لهذا المورد"
                );
                router.push("/forbidden");
            } else {
                // Handle other HTTP errors
                ErrorService.handleError(error);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
